import { render } from "./userPermission.vue?vue&type=template&id=e8a64638"
import script from "./userPermission.vue?vue&type=script&lang=js"
export * from "./userPermission.vue?vue&type=script&lang=js"

import "./userPermission.vue?vue&type=style&index=0&id=e8a64638&lang=scss"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__